import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from '../locales/resources';

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        fallbackLng: 'ro', // Default language
        debug: true, // For development
        interpolation: {
            escapeValue: false, // React will safe from XSS for you
        },
        resources,
    });

export default i18n;
